
const FinancialStatus = () => import('@/modules/financialStatus/index.vue');

export default [
  {
    path: '/status-financeiro',
    name: 'financial-status',
    component: FinancialStatus,
    meta: {
      isAvaliableInMenu: true,
      navbarTitle: 'Status Financeiro',
      menuData: {
        title: 'Status Financeiro',
        id: 'financialStatusSidebar',
        section: 'Financeiro',
        icon: 'dollar-sign',
      },
    },
  },
];

